import { forOwn, isArray, isObject } from 'lodash-es';

export function freezeDeep(obj: any): any {
  if (isObject(obj)) {
    Object.freeze(obj);
    forOwn(obj, (value: any) => {
      freezeDeep(value);
    });
  } else if (isArray(obj)) {
    return obj.map((o) => freezeDeep(o));
  }
}
